//这里是 车间工时管理 模块的路由文件

const basePath = "/admin/sys/";
export default [
    {
        path: `${basePath}login`,
        name: 'login',
        component: r => require.ensure([], () => r(require('@/views/sys/login')), 'sys')
    },
    {
        path: `${basePath}reset`,
        name: 'reset',
        component: r => require.ensure([], () => r(require('@/views/sys/reset')), 'sys')
    },
    {
        path: `*`,
        name: '404',
        component: r => require.ensure([], () => r(require('@/views/404')), 'sys')
    },
    {
        path: `${basePath}user`,
        name: 'user',
        component: r => require.ensure([], () => r(require('@/views/sys/user')), 'sys')
    },
    {
      path: `${basePath}restore`,
      name: 'restore',
      component: r => require.ensure([], () => r(require('@/views/sys/restore')), 'sys')
    },
]
